import * as React from "react";
import { IconProps } from "../types";

const UiCardOutline18px = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <rect
          x="2.75"
          y="2.75"
          width="12.5"
          height="12.5"
          rx="2"
          ry="2"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <rect
          x="5.75"
          y="5.75"
          width="6.5"
          height="3.5"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          data-color="color-2"
        />
        <line
          x1="5.75"
          y1="12.25"
          x2="8.75"
          y2="12.25"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          data-color="color-2"
        />
        <line
          x1="11.75"
          y1="12.25"
          x2="12.25"
          y2="12.25"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          data-color="color-2"
        />
      </svg>
    );
  },
);

export default UiCardOutline18px;
